/**
 * Module-level store for bulk admin operations (scrape, mirror, import).
 * Lives outside React so progress survives component unmount when user switches tabs.
 * Components subscribe via subscribe() and read via getState().
 */

export type BulkProgress = { current: number; total: number; handle: string; inserted: number; errors: number } | null;
export type BulkVideoProgress = { current: number; total: number; handle: string; mirrored: number } | null;
export type BulkCarouselProgress = { current: number; total: number; handle: string; slides: number } | null;
export type BulkThumbProgress = { current: number; total: number; handle: string; mirrored: number } | null;
export type ImportProgress = { runs: number; total: number; inserted: number; updated: number } | null;

export type BulkOpsState = {
  bulkProgress: BulkProgress;
  bulkVideoProgress: BulkVideoProgress;
  bulkCarouselProgress: BulkCarouselProgress;
  bulkThumbProgress: BulkThumbProgress;
  importProgress: ImportProgress;
  importing: boolean;
  scraping: string | null;
  mirroringVideo: string | null;
};

const initialState: BulkOpsState = {
  bulkProgress: null,
  bulkVideoProgress: null,
  bulkCarouselProgress: null,
  bulkThumbProgress: null,
  importProgress: null,
  importing: false,
  scraping: null,
  mirroringVideo: null,
};

let state: BulkOpsState = { ...initialState };
const listeners = new Set<() => void>();

export function getState(): BulkOpsState {
  return state;
}

export function setState(updates: Partial<BulkOpsState>): void {
  state = { ...state, ...updates };
  listeners.forEach((l) => l());
}

export function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
